import { BLOB_STORAGE_URL } from "serverDetails";
import { notNullOrUndefined } from "pages/FieldReportsPage/helpers";

// NOTE: If changing this file, don't forget to make the same changes in the
// corresponding file in WebAdminUserInterface
export const parsePanoramaURL = (
  panoramaGuid: string,
  currentField?: number | null
): string =>
  `${BLOB_STORAGE_URL}/PanoTemplateWrapper/PanoTemplate/index.html?guid=${panoramaGuid}${
    notNullOrUndefined(currentField) ? `&currentfield=${currentField}` : ""
  }`;
